<template>
  <!-- <v-container class="py-0"> -->
  <v-row>
    <v-col class="py-0" cols="12">
      <v-img
        :src="require(`@/assets/img/closing/${lg}`)"
        :lazy-src="require(`@/assets/img/closing/${sm}`)"
        :srcset="`${require(`@/assets/img/closing/${sm}`)} 600w,
        ${require(`@/assets/img/closing/${lg}`)} 1320w`"
        sizes="(max-width: 600px) 600px, 1320px"
        height="250"
        width="100%"
        gradient="rgba(0, 0, 0, .8) 50%, rgba(255, 255, 255, .1)"
        class="d-flex justify-center align-center"
      >
        <v-row class="d-flex flex-column justify-center align-center">
          <v-col cols="11">
            <p class="text-h6 font-weight-light text-center white--text">
              Sign up for our newsletter to stay up to date on news from MicroTone Guitars!
            </p>
          </v-col>
          <cta-btn buttonWidth="250"/>
          <v-btn x-large width="250"
          class="my-2 thicc" color="secondary"
          @click="contactFormRedirect"
          >
            Contact Us
          </v-btn>
        </v-row>
      </v-img>
    </v-col>
  </v-row>
  <!-- </v-container> -->
</template>

<script>
export default {
  data() {
    return {
      sm: 'sm.jpg',
      lg: 'lg.jpg',
    };
  },
  methods: {
    contactFormRedirect() {
      const mcContactFormURL = 'https://us5.list-manage.com/contact-form?u=00f788a46f27c498a7b257f53&form_id=a671da4f9ba814899726a0035dd3d6ca';
      window.open(mcContactFormURL, '_blank');
    },
  },
};
</script>

<style>
.thicc {
  font-weight: 900;
}
</style>
